/* eslint-disable @typescript-eslint/no-use-before-define */
import * as React from 'react';
import {
  Button,
  ButtonVariant,
  ButtonWidth,
} from '@practicegenius/pg-ui/src/base/Material/components/Button';
import {SocialAuthIntegration} from '@practicegenius/domain/src/data/integrations';
import {Modal} from '../../../components/Modal/Modal';
import {ModalButtons} from '../../../components/Modal/layout';
import {platformLabels} from '../../../screens/social-auth/lang';
import ServiceBrand from '../../../utils/ServiceBrand';
import {Content, Title} from '../../../shared/utils/sharedStyledElements';

type Props = {
  isOpen: boolean;
  close: () => void;
  provider: SocialAuthIntegration;
};

export function UnregisteredSocialAccountModal({
  isOpen,
  close,
  provider,
}: Props) {
  return (
    <Modal isOpen={isOpen} close={close}>
      <Title>{platformLabels[provider]} account not connected</Title>
      <Content>
        Your {platformLabels[provider]} account is not connected to your{' '}
        {ServiceBrand.lang.hubProduct} account. Log in with your username and
        password. You can connect your {platformLabels[provider]} account in
        your profile settings.
      </Content>
      <ModalButtons>
        <Button
          variant={ButtonVariant.outlined}
          width={ButtonWidth.ELASTIC}
          onClick={close}
        >
          Log In With Username
        </Button>
      </ModalButtons>
    </Modal>
  );
}
